import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { AddonAction } from 'models/AddonAction';
import { TradeWay } from 'models/TradeWay';
import { FC } from 'react';
import { connect } from 'react-redux';
import { getFormQuoteResult, getSidePanelAddonActionOrDefault, getSidePanelTradeWayOrDefault } from 'state/selectors';
import { AppState } from 'state/state.model';
import { WorkspaceType } from 'state/workspaces/model';

import { getTradeWayIntlKey } from './TradeWayLiteral.helper';

interface StateProps {
  tradeWay: TradeWay;
  addonAction: AddonAction;
  isExecOnlyAddon?: boolean;
}
interface OwnProps {
  className?: string;
}
interface Props extends StateProps, OwnProps {}
export const TradeWayLiteral: FC<Props> = ({ className, tradeWay, isExecOnlyAddon, addonAction }) => {
  const isInternalUser = useIsInternalUser();

  return (
    <span className={classNames(className, 'fw-semibold lh-1')}>
      <FormattedMessage id={getTradeWayIntlKey(tradeWay, isInternalUser, addonAction, isExecOnlyAddon)} />
    </span>
  );
};

interface ConnectOwnProps extends OwnProps {
  tabId: string;
  workspaceType: WorkspaceType;
}
const mapStateToProps = (state: AppState, { tabId, workspaceType }: ConnectOwnProps): StateProps => ({
  tradeWay: getSidePanelTradeWayOrDefault(state, tabId),
  addonAction: getSidePanelAddonActionOrDefault(state, tabId, workspaceType),
  isExecOnlyAddon: getFormQuoteResult(state, workspaceType, tabId)?.isExecOnlyAddon,
});
export const ConnectedTradeWayLiteral = connect(mapStateToProps)(TradeWayLiteral);
